import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { ProviderDeletion } from '@shipstation/connections-ui';
import { DirectCarrierDeletion } from '@shipstation/connections-ui/direct';
import { noop } from 'ui-components/default-props/noop';

import { useCuiApiConfig } from './helpers/use-cui-api-config';
import { useCuiContextProps } from './helpers/use-cui-context-props';
import { useEnableDirectModeCarriers } from '../feature-flags/hooks/use-enable-direct-mode-carriers';

import { useCommonCuiProps } from './helpers/use-common-cui-props';

export const CuiProviderDeletion = ({ providerApiCode, providerType, accountId, onRemoveAccount, onError = noop, onCancel = noop }) => {
  const isDirectMode = useEnableDirectModeCarriers();
  const commonCuiProps = useCommonCuiProps();
  const cuiApiConfig = useCuiApiConfig();
  const cuiContextProps = useCuiContextProps();

  const directContextProps = useMemo(
    () => ({
      ...cuiContextProps,
      onCancel,
      onError,
      onRemoveAccount,
    }),
    [cuiContextProps, onCancel, onError, onRemoveAccount],
  );

  if (isDirectMode) {
    return (
      <DirectCarrierDeletion
        accountId={accountId}
        apiConfig={cuiApiConfig}
        contextProps={directContextProps}
        providerApiCode={providerApiCode}
        providerType={providerType}
      />
    );
  }

  return (
    <ProviderDeletion
      {...commonCuiProps}
      accountId={accountId}
      onCancel={onCancel}
      onError={onError}
      onRemoveAccount={onRemoveAccount}
      providerApiCode={providerApiCode}
      providerType={providerType}
    />
  );
};

CuiProviderDeletion.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  providerType: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired,
  onRemoveAccount: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
